/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import subDays from 'date-fns/sub_days';
import addDays from 'date-fns/add_days';
import isSameDay from 'date-fns/is_same_day';
import isBefore from 'date-fns/is_before';
import isAfter from 'date-fns/is_after';
import isWithinRange from 'date-fns/is_within_range';
import format from 'date-fns/format';
import styles from './styles.scss';

const kWeekdayShortNames = {
  zh: ['日', '一', '二', '三', '四', '五', '六'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
};

const kMonthNames = {
  zh: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};

const defaultProps = {
  selected: null,
  anchor: null,
  onSelect: () => {},
  disabled: null,
  onPrevMonth: () => {},
  onNextMonth: () => {},
};

const propTypes = {
  year: React.PropTypes.number.isRequired,
  month: React.PropTypes.number.isRequired,
  selected: React.PropTypes.instanceOf(Date),
  anchor: React.PropTypes.instanceOf(Date),
  onSelect: React.PropTypes.func,
  disabled: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.instanceOf(Date)),
    React.PropTypes.func,
  ]),
  locale: React.PropTypes.string.isRequired,
  onPrevMonth: React.PropTypes.func,
  onNextMonth: React.PropTypes.func,
};

class MonthCalendar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      year: props.year,
      month: props.month,
      selected: props.selected,
      disabled: props.disabled,
      anchor: props.anchor,
    };
    this.handleNextMonth = this.handleNextMonth.bind(this);
    this.handlePrevMonth = this.handlePrevMonth.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { year, month, selected, anchor, disabled } = nextProps;
    if (year !== this.props.year) {
      this.setState({ year });
    }
    if (month !== this.props.month) {
      this.setState({ month });
    }
    if (selected !== this.props.selected) {
      this.setState({ selected });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled });
    }
    if (anchor !== this.props.anchor) {
      this.setState({ anchor });
    }
  }

  weekDaysOfMonth(index) {
    const { year, month } = this.state;
    const som = new Date(year, month, 1);
    const somOffset = som.getDay();
    if (index === 0) {
      return [
        ..._.reverse(_.range(1, somOffset + 1).map(i => subDays(som, i))),
        ..._.range(7 - somOffset).map(i => addDays(som, i)),
      ];
    }
    return _.range(
      (7 - somOffset) + ((index - 1) * 7),
      (7 - somOffset) + (index * 7),
    ).map(i => addDays(som, i));
  }

  handlePrevMonth() {
    let { month, year } = this.state;
    if (month === 0) {
      month = 11;
      year -= 1;
    } else {
      month -= 1;
    }
    this.setState({ year, month });

    const { onPrevMonth } = this.props;
    onPrevMonth(year, month);
  }

  handleNextMonth() {
    let { month, year } = this.state;
    if (month === 11) {
      month = 0;
      year += 1;
    } else {
      month += 1;
    }
    this.setState({ year, month });

    const { onNextMonth } = this.props;
    onNextMonth(year, month);
  }

  render() {
    const { locale, onSelect } = this.props;
    const { month, year, selected, disabled, anchor, hover } = this.state;
    const weekdayNames = kWeekdayShortNames[locale];
    const monthNames = kMonthNames[locale];

    const dateBox = (date) => {
      let className = styles.box;
      let onClick = () => onSelect(date);

      if (date.getMonth() === month) {
        className = `${className} ${styles.inMonth}`;
      }
      if (!_.isNil(selected) && isSameDay(date, selected)) {
        className = `${className} ${styles.selected}`;
      }
      if (!_.isNil(disabled)) {
        if (_.isArray(disabled) && disabled.findIndex(d => isSameDay(d, date))) {
          className = `${className} ${styles.disabled}`;
          onClick = () => {};
        } else if (disabled(date)) {
          className = `${className} ${styles.disabled}`;
          onClick = () => {};
        }
      }
      if (!_.isNil(hover) && !_.isNil(anchor)) {
        let [start, end] = [hover, anchor];
        if (isAfter(start, end)) {
          [start, end] = [end, start];
        }
        if (isWithinRange(date, start, end)) {
          className = `${className} ${styles.ranged}`;
          if (isBefore(date, anchor)) {
            className = `${className} ${styles.rangedLeft}`;
          } else if (isAfter(date, anchor)) {
            className = `${className} ${styles.rangedRight}`;
          }
        }
        if (isSameDay(date, anchor)) {
          className = `${className} ${styles.anchor}`;
        }
      }

      return (
        <Link
          key={format(date, 'YYYYMMDD')}
          className={className}
          onClick={onClick}
          onMouseOver={() => {
            if (!_.isNil(anchor)) {
              this.setState({ hover: date });
            }
          }}
        >
          {date.getDate()}
        </Link>
      );
    };

    return (
      <div className={styles.month}>
        <div className={styles.navs}>
          <Link className={styles.navLeft} onClick={this.handlePrevMonth}>
            <i className="fa fa-chevron-circle-left" />
          </Link>
          <Link className={styles.navCurr}>
            {year}{' - '}{monthNames[month]}
          </Link>
          <Link className={styles.navRight} onClick={this.handleNextMonth}>
            <i className="fa fa-chevron-circle-right" />
          </Link>
        </div>
        <div className={styles.header}>
          {weekdayNames.map(w => (
            <span key={w} className={styles.box}>{w}</span>
          ))}
        </div>
        <div className={styles.dates}>
          <div className={styles.week}>
            {this.weekDaysOfMonth(0).map(d => dateBox(d))}
          </div>
          <div className={styles.week}>
            {this.weekDaysOfMonth(1).map(d => dateBox(d))}
          </div>
          <div className={styles.week}>
            {this.weekDaysOfMonth(2).map(d => dateBox(d))}
          </div>
          <div className={styles.week}>
            {this.weekDaysOfMonth(3).map(d => dateBox(d))}
          </div>
          <div className={styles.week}>
            {this.weekDaysOfMonth(4).map(d => dateBox(d))}
          </div>
          <div className={styles.week}>
            {this.weekDaysOfMonth(5).map(d => dateBox(d))}
          </div>
        </div>
      </div>
    );
  }
}

MonthCalendar.defaultProps = defaultProps;
MonthCalendar.propTypes = propTypes;

const mapStateToProps = state => ({
  locale: state.intl.locale,
});

export default connect(mapStateToProps, null)(injectIntl(MonthCalendar));




// WEBPACK FOOTER //
// ./src/components/MonthCalendar/index.jsx